"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CmsRepositoryImpl {
    fetcherAmplify;
    constructor(fetcherAmplify) {
        this.fetcherAmplify = fetcherAmplify;
    }
    dataFunds;
    async listFundContent() {
        if (this.dataFunds)
            return this.dataFunds;
        let response;
        if (!this.dataFunds) {
            response = await this.fetcherAmplify.get(`/v1/cms/Funds`);
            this.dataFunds = response;
        }
        return response;
    }
}
exports.default = CmsRepositoryImpl;
//# sourceMappingURL=CmsRepositoryImpl.js.map